import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import React from 'react';
import { NodeViewWrapper } from '@tiptap/react';
import { FiImage, FiExternalLink, FiLayers } from 'react-icons/fi';

// Card Node View Component
const CardNodeView = ({ node, updateAttributes, selected }) => {
  const { image, title, description, linkText, linkUrl } = node.attrs;

  const handleChange = (field, value) => {
    updateAttributes({ [field]: value });
  };

  return (
    <NodeViewWrapper className={`card-block ${selected ? 'selected' : ''}`}>
      <div className="card-edit-bar">
        <FiLayers size={14} />
        <span>Content Card</span>
      </div>
      <div className="card-image-section">
        {image ? (
          <img src={image} alt={title} className="card-image" />
        ) : (
          <div className="card-image-placeholder">
            <FiImage size={32} />
            <span>No image</span>
          </div>
        )}
        <input
          type="url"
          value={image}
          onChange={(e) => handleChange('image', e.target.value)}
          placeholder="Image URL..."
          className="card-image-input"
        />
      </div>
      <div className="card-content">
        <input
          type="text"
          value={title}
          onChange={(e) => handleChange('title', e.target.value)}
          placeholder="Card title..."
          className="card-title-input"
        />
        <textarea
          value={description}
          onChange={(e) => handleChange('description', e.target.value)}
          placeholder="Card description..."
          className="card-description-input"
          rows={3}
        />
        <div className="card-link-row">
          <input
            type="text"
            value={linkText}
            onChange={(e) => handleChange('linkText', e.target.value)}
            placeholder="Link text..."
            className="card-link-text-input"
          />
          <input
            type="url"
            value={linkUrl}
            onChange={(e) => handleChange('linkUrl', e.target.value)}
            placeholder="https://..."
            className="card-link-url-input"
          />
        </div>
        {linkUrl && linkText && (
          <a
            href={linkUrl}
            className="card-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            {linkText}
            <FiExternalLink size={12} />
          </a>
        )}
      </div>
    </NodeViewWrapper>
  );
};

// Card Extension
export const Card = Node.create({
  name: 'card',
  group: 'block',
  atom: true,
  draggable: true,

  addAttributes() {
    return {
      image: {
        default: '',
      },
      title: {
        default: 'Card Title',
      },
      description: {
        default: 'This is a description for the card. Add your content here.',
      },
      linkText: {
        default: 'Learn More',
      },
      linkUrl: {
        default: '',
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'div[data-type="card"]',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes(HTMLAttributes, { 'data-type': 'card' }), 0];
  },

  addNodeView() {
    return ReactNodeViewRenderer(CardNodeView);
  },

  addCommands() {
    return {
      insertCard:
        (attrs = {}) =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs: {
              image: attrs.image || '',
              title: attrs.title || 'Card Title',
              description: attrs.description || 'This is a description for the card.',
              linkText: attrs.linkText || 'Learn More',
              linkUrl: attrs.linkUrl || '',
            },
          });
        },
    };
  },
});

export default Card;
